(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-faq-accordion')) {
    class CcFaqAccordion extends HTMLElement {
      connectedCallback() {
        this.singleOpen = this.dataset.singleOpen === 'true';
        this.items = Array.from(this.querySelectorAll('.cc-faq__item'));
        this.items.forEach((details) => {
          const summary = details.querySelector('summary');
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            if (details.open) {
              this.close(details);
            } else {
              if (this.singleOpen) {
                this.items.forEach((other) => {
                  if (other !== details && other.open) this.close(other);
                });
              }
              this.open(details);
            }
          });
        });
      }

      get reduceMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      animate(content, from, to, onFinish) {
        if (content._ccAnimation) content._ccAnimation.cancel();
        if (this.reduceMotion || !content.animate) {
          onFinish();
          return;
        }
        const animation = content.animate(
          { height: [`${from}px`, `${to}px`] },
          { duration: 300, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
        );
        content._ccAnimation = animation;
        animation.onfinish = () => {
          content._ccAnimation = null;
          onFinish();
        };
      }

      open(details) {
        const content = details.querySelector('.cc-faq__answer');
        details.open = true;
        const height = content.scrollHeight;
        this.animate(content, 0, height, () => {});
      }

      close(details) {
        const content = details.querySelector('.cc-faq__answer');
        const height = content.offsetHeight;
        this.animate(content, height, 0, () => {
          details.open = false;
        });
      }
    }

    customElements.define('cc-faq-accordion', CcFaqAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-image-slider')) {
    class CcImageSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cc-slider__track');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.prevBtn = this.querySelector('[data-cc-prev]');
        this.nextBtn = this.querySelector('[data-cc-next]');
        this.dotsWrap = this.querySelector('[data-cc-dots]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
        });

        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.track);

        this.index = 0;
        this.onResize();
        this.setupAutoplay();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.stop();
      }

      get step() {
        if (this.slides.length < 2) return this.track.clientWidth;
        return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
      }

      get maxIndex() {
        const perView = Math.max(1, Math.round(this.track.clientWidth / this.step));
        return Math.max(0, this.slides.length - perView);
      }

      onResize() {
        this.buildDots();
        this.onScroll();
      }

      buildDots() {
        if (!this.dotsWrap) return;
        const count = this.maxIndex + 1;
        if (this.dotsWrap.children.length === count) return;
        this.dotsWrap.innerHTML = '';
        if (count < 2) return;
        for (let i = 0; i < count; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cc-slider__dot';
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => this.go(i));
          this.dotsWrap.appendChild(dot);
        }
      }

      onScroll() {
        const step = this.step || 1;
        this.index = Math.min(this.maxIndex, Math.round(this.track.scrollLeft / step));
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        if (atEnd) this.index = this.maxIndex;
        if (this.prevBtn) this.prevBtn.disabled = this.index <= 0;
        if (this.nextBtn) this.nextBtn.disabled = this.index >= this.maxIndex;
        if (this.dotsWrap) {
          Array.from(this.dotsWrap.children).forEach((dot, i) => {
            dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
          });
        }
      }

      go(i, wrap = false) {
        const max = this.maxIndex;
        let target = i;
        if (wrap && target > max) target = 0;
        target = Math.max(0, Math.min(max, target));
        this.track.scrollTo({
          left: this.slides[target].offsetLeft - this.slides[0].offsetLeft,
          behavior: this.reduceMotion ? 'auto' : 'smooth',
        });
      }

      setupAutoplay() {
        if (this.dataset.autoplay !== 'true' || this.reduceMotion || this.slides.length < 2) return;
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        const pause = () => this.stop();
        const resume = () => this.play();
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this.track.addEventListener('touchstart', pause, { passive: true });
        this.play();
      }

      play() {
        this.stop();
        if (this.dataset.autoplay !== 'true') return;
        this.timer = setInterval(() => this.go(this.index + 1, true), this.speed);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }
    }

    customElements.define('cc-image-slider', CcImageSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-results')) {
    class CcResults extends HTMLElement {
      connectedCallback() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || !('IntersectionObserver' in window)) return;

        this.classList.add('cc-results--animate');
        this.counters = Array.from(this.querySelectorAll('[data-cc-count]'));
        this.counters.forEach((el) => (el.textContent = '0'));

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.observer.disconnect();
              requestAnimationFrame(() => {
                this.classList.add('is-visible');
                this.countUp();
              });
            });
          },
          { threshold: 0.25 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      countUp() {
        const duration = 1400;
        const start = performance.now();
        const step = (now) => {
          const t = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - t, 3);
          this.counters.forEach((el) => {
            el.textContent = Math.round(parseInt(el.dataset.ccCount, 10) * eased);
          });
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
    }

    customElements.define('cc-results', CcResults);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-track-order')) {
    class CcTrackOrder extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="tracking_number"]');
        this.error = this.querySelector('.cc-track__error');
        if (!this.form || !this.input) return;

        this.input.addEventListener('input', () => this.setError(false));
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          const value = this.input.value.trim();
          if (!value) {
            this.setError(true);
            this.input.focus();
            return;
          }
          const prefix = this.dataset.prefix || 'https://t.17track.net/en#nums=';
          const url = prefix + encodeURIComponent(value);
          const link = document.createElement('a');
          link.href = url;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
      }

      setError(show) {
        if (!this.error) return;
        this.error.hidden = !show;
        this.input.setAttribute('aria-invalid', show ? 'true' : 'false');
      }
    }

    customElements.define('cc-track-order', CcTrackOrder);
  }

  } catch(e) { console.error(e); }
})();
})();
